module.exports = __webpack_public_path__ + "static/headshot-nick-anderson-2x.0bacbf64.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-nick-anderson-2x.png
// module id = 135
// module chunks = 35783957827783 152909308826437